<template>
  <section
    class="Modal ModalAddedToCart" 
    @click.self="closeModal"
  >
    <transition type="animation" name="bounce" mode="out-in">
      <div v-show="animate" class="Modal-inner">
        
        <!-- Modal-Header -->
        <div class="Modal-status">
          <div class="svg-container">      
              <svg width="63" height="55" viewBox="0 0 63 55" fill="none" xmlns="http://www.w3.org/2000/svg" class="cartAdded">
                  <title>Icon/Cart_Added</title>
                      <g>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M3.58592 14.6364H1.84841C0.827563 14.6364 0 13.8088 0 12.7879C0 11.767 0.827563 10.9394 1.84841 10.9394H3.58592C6.64139 10.9521 9.37804 12.8328 10.4851 15.6808L11.5064 18.3333H42.5135C43.1076 18.3328 43.6657 18.6178 44.0135 19.0993C44.3614 19.5809 44.4566 20.2003 44.2695 20.7641L40.4202 32.3448C39.1615 36.124 35.6233 38.6716 31.6402 38.6667H14.7873C13.7665 38.6667 12.9389 39.4943 12.9389 40.5152C12.9389 41.536 13.7665 42.3636 14.7873 42.3636H36.9683C37.9891 42.3636 38.8167 43.1912 38.8167 44.2121C38.8167 45.233 37.9891 46.0606 36.9683 46.0606H14.7873C11.9349 45.9936 9.59892 43.773 9.38749 40.9276C9.17606 38.0822 11.1582 35.5407 13.9694 35.0529L7.03784 17.007C6.48881 15.5785 5.11633 14.6359 3.58592 14.6364ZM36.899 31.1757L39.9489 22.0303H12.9389L17.9066 34.9697H31.6403C34.027 34.9685 36.1452 33.4403 36.899 31.1757Z" fill="#0B232D"/>
                          <circle cx="17.5" cy="52.5" r="2.5" fill="#0B232D"/>
                          <circle cx="30.5" cy="52.5" r="2.5" fill="#0B232D"/>  
                          <circle class="circle" cx="44.5" cy="18.5" r="17.5" fill="white" stroke="#34A853" stroke-width="2"/>
                          <path class="check" d="M37 19L42.5 24.5L54 13" stroke="#34A853" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
              </svg>
          </div>

          <p>
              Votre article a bien été ajouté au panier
          </p>
        </div>
        
        <!-- Modal-Content -->
        <div class="Modal-product">
          <div class="img-container">
              <img :src="productThuumbnail" :alt="productName"/>
          </div>

          <p :inner-html.prop="productName"></p>
        </div>
        
        <!-- Modal-Button -->
        <div class="Modal-actions">
          <a :href="catalogUrl" class="Button Button-border-primary">Continuer mes achats</a>
          <a :href="baseUrl + this.cartUrl" class="Button Button-success">Aller au panier</a>
        </div>

      </div>
    </transition>

  </section>
</template>

<script>
import { mapGetters } from "vuex";


export default {
  name: "ModalCartAdded",

  props: {
    showModal: Boolean,
  },

  data() {
    return {
      animate: false,
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      catalogUrl: '',
    };
  },

  computed: {
    ...mapGetters({
      productName: "getProductName",
      productThuumbnail:"getProductThumbnail",
      storeUrlPrefix: "getStoreUrlPrefix",
      cartUrl: "getProductCartUrl",
      breadcrumbs: "getProductBreadcrumbs"
    }),
  },

  watch: {
   
  },

  mounted() {
      this.animate = true;
      localStorage.getItem('catalogUrl') ? this.catalogUrl = localStorage.getItem('catalogUrl') : this.breadcrumbs[1].url;
  }, 
  

  methods: {
    closeModal () {
      return this.$emit("Modal::close");
    },
  },
  
};
</script>

<style lang="scss" scoped>
  .Modal.ModalAddedToCart {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    .Modal-inner {
        margin: 0 auto;
        padding: 50px 30px;
        width: 90%;
        border-radius: 10px;
        background: $color-white;

        @include breakpoint(md) {
          width: 800px;
          margin: 0;  
          padding: 50px 80px;
        }

        .Modal-status {
            p {

                font-size: 3rem;
                line-height: 3.5rem;
                font-weight: 400;

                @include breakpoint(md) {
                    font-size: 3rem;
                    line-height: 3.5rem;  
                }
            }
        }

        .Modal-product {
            margin: 40px 0;
            padding: 20px 0;
            border-top: 1px solid #D7DFE2;
            border-bottom: 1px solid #D7DFE2;

            @include breakpoint(md) {
                display: flex;
                align-items: center;
                gap: 30px;
            }

            .img-container {
                margin: 0 auto;
                max-width: 90px;
                max-height: 90px;

                img {
                    max-height: 90px;
                }
            }

            p {
                font-weight: 600;
                font-size: 1.6rem;
            }
        }

        .Modal-actions{
            .Button {
              display: block;
              margin-bottom: 20px;
              padding: 15px;
              font-size: 1.4rem;  
            }
            
            
            @include breakpoint(md) {
                display: flex;
                gap: 20px;

                .Button {
                    margin-bottom: 0px;
                    
                }
            }
        }
    }
  }

  /* svg animation */
  .Modal.ModalAddedToCart .svg-container {
    svg {
      .circle {
        stroke-dasharray: 110px;
        stroke-dashoffset: 110px;
        animation: strokeAnime .5s ease .4s forwards;
      }

      .check {
        stroke-dasharray: 25px;
        stroke-dashoffset: 25px;
        animation: strokeAnime .3s ease .7s forwards;
      }
    }

    @keyframes strokeAnime {
      to {
        stroke-dashoffset: 0;
      }
    }
  }

// --- bouncing enter animation
.bounce-enter-active {
  animation: bounced .7s ease;
}


@keyframes bounced {
  0% {
    transform: translateY(100vh);
  }
  35% {
    transform: translateY(-10vh);
  }
  70% {
    transform: translateY(30px);
  }
  100% {
    transform: translateY(0);
  }
}
</style>